import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { selectModalTabId } from "../../../selectors/selectModalTabId";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { IdModal } from "../../modals/IdModal";
import { actionCoopMemberResponse, TypeActionCoopInfo, } from "../actionCoop";
export var epicCoopMembers = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.MemberRequest), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.CoopMemberInfo,
            props: {
                coopId: action.coopId,
                playerId: action.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            var tabId = selectModalTabId(state$.value, IdModal.Coop);
            return of(actionCoopMemberResponse(res.coop, res.member, tabId));
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopMembers.ts
// module id = 1814
// module chunks = 3